import React from 'react';
import { MapPin, Calendar, Building } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Link } from 'react-router-dom';
import { projects } from '../mockData';

const Projects = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Our <span className="text-red-600">Projects</span>
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6" />
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Delivering excellence across major oil & gas developments in the Middle East and beyond
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => {
            // Define which projects have detail pages
            const projectRoutes = {
              "Pump Packaging Project": "/projects/mpp-project",
              "West To East Pipeline Project": "/projects/west-to-east",
              "EPCM For Fujairah BC Project - ADNOC Onshore": "/projects/fujairah-bc",
              "Buhasa Tie-Ins (2021-2025) Package 1(P12516) ADNOC Onshore": "/projects/buhasa-tie-ins",
              "EPC For ASAB Phase II Project-Camp Approvals and Engineering Services": "/projects/asab-phase2",
              "Rumaila Oil Field Development": "/projects/rumaila",
              "Tawke Oil Field": "/projects/tawke",
              "Al Halfaya Oil Field Development": "/projects/al-halfaya",
              "West Qurna Phase 2 Development": "/projects/west-qurna",
              "Mombasa-Nairobi Pipeline Inspection": "/projects/mombasa-nairobi"
            };
            
            const isClickable = projectRoutes[project.title] !== undefined;
            const projectLink = projectRoutes[project.title] || "";
            
            const ProjectCard = (
              <Card
                key={project.id}
                className="group border-none shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden cursor-pointer bg-white"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent" />
                  <div className="absolute top-4 right-4">
                    <span className="px-3 py-1 bg-red-600 text-white text-xs font-semibold rounded-full">
                      {project.category}
                    </span>
                  </div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <h3 className="text-xl font-bold text-white mb-2">{project.title}</h3>
                    <div className="flex items-center gap-2 text-slate-300 text-sm">
                      <MapPin className="w-4 h-4" />
                      <span>{project.location}</span>
                    </div>
                  </div>
                </div>
                <CardContent className="p-6">
                  <p className="text-slate-600 leading-relaxed mb-4 line-clamp-3">{project.description}</p>
                  <div className="space-y-2 border-t border-slate-100 pt-4">
                    <div className="flex items-center gap-2 text-sm">
                      <Building className="w-4 h-4 text-red-600" />
                      <span className="text-slate-600">
                        <span className="font-semibold">Client:</span> {project.client}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 text-sm">
                      <Calendar className="w-4 h-4 text-red-600" />
                      <span className="text-slate-600">
                        <span className="font-semibold">Year:</span> {project.year}
                      </span>
                    </div>
                  </div>
                  <div className="mt-4 flex items-center text-red-600 font-semibold group-hover:gap-2 transition-all">
                    <span>{isClickable ? 'Learn More' : 'View Details'}</span>
                    <span className="transform group-hover:translate-x-2 transition-transform">→</span>
                  </div>
                </CardContent>
              </Card>
            );

            return isClickable ? (
              <Link key={project.id} to={projectLink}>
                {ProjectCard}
              </Link>
            ) : (
              ProjectCard
            );
          })}
        </div>

        {/* More Projects Button */}
        <div className="mt-12 text-center">
          <Link
            to="/projects/more"
            className="inline-flex items-center gap-2 px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
          >
            <span>View More Projects</span>
            <span className="text-xl">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Projects;